/**
 * @generated SignedSource<<c99e09e13965701105a32ef8211db8f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectDetails_account$data = {
  readonly id: number;
  readonly people: ReadonlyArray<{
    readonly first_name: string;
    readonly id: number;
    readonly is_placeholder: boolean;
    readonly last_name: string;
    readonly " $fragmentSpreads": FragmentRefs<"PersonRows_people">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectGroupRow_account">;
  readonly " $fragmentType": "ProjectDetails_account";
};
export type ProjectDetails_account$key = {
  readonly " $data"?: ProjectDetails_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectDetails_account">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "peopleFilter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "plannerStartDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectDetails_account",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "where",
          "variableName": "peopleFilter"
        }
      ],
      "concreteType": "people",
      "kind": "LinkedField",
      "name": "people",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "is_placeholder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "first_name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "last_name",
          "storageKey": null
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "plannerStartDate",
              "variableName": "plannerStartDate"
            }
          ],
          "kind": "FragmentSpread",
          "name": "PersonRows_people"
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "peopleFilter",
          "variableName": "peopleFilter"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ProjectGroupRow_account"
    }
  ],
  "type": "accounts",
  "abstractKey": null
};
})();

(node as any).hash = "11917c86076fb1320592a1aeb89b7cc3";

export default node;
